<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="primary">
<h1>Primary</h1>
<p>Mostly, she remembered the rain. It was grey, dark, and drizzly. The artificial lights inside the supermarket hummed. Their time was all there was, there was nothing else. She remembered touching his face, as smooth as polished ebony, observing the grooves and contours, the valleys and peaks. His eyes were ones of sadness but she didn’t see it then when she looked into them, she only saw the sea. Of all the days they spent together, that was the only piece she could find. She wondered why this was. Perhaps because that was the last time she ever saw him. One day, what she figured would be a never-ending course, and the next, nothing at all. One meant to be a longer voyage, forced to a sudden halt all too quickly.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?65e9380c